// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1ISJu","header":"PatientQuestionnaire_header__3XI1G","info":"PatientQuestionnaire_info__1Jfs7"};